<template>
  <v-layout column class="mx-2">
     <v-progress-linear
        v-if="showProgress === true"
        indeterminate
        color="secondary"
      ></v-progress-linear>
    <vue-snotify></vue-snotify>
    <v-card class="mx-auto" flat>
      <v-card-title class="headline font-weight-regular justify-space-between">
        <span>Login</span>
      </v-card-title>
       <v-divider class="secondary"></v-divider>
      <v-card-text>
        <span class=" grey--text text--darken-1">
         ThinkAir is undergoing a digital transformation journey , investing in a new technology platform to bring schools fantastic digital shows and teacher’ resources to support the STEAM curriculum. You will be able to have a theatre experience in your classroom.

        </span>
        <v-form ref="loginForm" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6">
              <v-text-field
                v-model.trim="userEmail"
                outlined
                label="Email"
                append-icon="icons8-envelope-3"
                hide-details="auto"
                :rules="emailRules"

                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6">
              <v-text-field
                v-model.trim="userPassword"
                outlined
                label="Password"
                :append-icon="show ? 'icons8-eye' : 'icons8-invisible'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                :rules="passwordRules"
                hide-details="auto"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="ml-3">
        <p>
         Don't have an account? <router-link
          :to="{ path: 'register' }"
          replace
          class="btn btn-link"
          >Register</router-link
        > </p>
        <p class="ml-4">
        Forgot Password? <router-link
          :to="{ path: 'reset-password' }"
          replace
          class="btn btn-link"
          >Reset password</router-link
        ></p>
        <v-spacer></v-spacer>

        <v-btn
          class="px-8"
          color="primary"
          depressed
          @click="login()"
        >
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    valid: true,
    show: false,
    userEmail: "",
    userPassword: "",
    showProgress: false, // to show loading bar
    //validation rules
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    passwordRules: [(v) => !!v || "Password is required"],
  }),
  methods: {
    checkCurruser(){
      var t = this;
      var currentUser = [];
      //console.log('id: ' + t.$store.getters.currUser.uid); 
        t.$firebase.db
          .collection("users")
          .doc(t.$store.getters.currUser.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              this.key = doc.id;
              var document = doc.data();
              document.id = doc.id;
              currentUser = document;
              //console.log('doc exists')
            } else {
              // alert("No such document!");
            }
          });
        return currentUser;
    },
    login() {
      this.userEmail=this.userEmail.toLowerCase();
      var t = this;
       if (this.$refs.loginForm.validate()) {
        this.$firebase.auth
          .signInWithEmailAndPassword(t.userEmail, t.userPassword)
          .then((data) => {
            //this.showProgress === true;
            this.$store.commit("setUser", data.user);

            this.$store.commit("user/setUserProfile", [
              "userID",
              data.user.userID,
            ]);

            this.$store.commit("user/setUserProfile", [
              "emailVerified",
              data.user.emailVerified,
            ]);

            this.$store.commit("user/setUserProfile", [
              "displayName",
              data.user.displayName,
            ]);
            this.$store.commit("user/setUserProfile", [
              "email",
              data.user.email,
            ]);
            var user = t.checkCurruser();
            setTimeout(function(){           
              t.showProgress = true; 
              t.$router.replace("/").catch((err) => {});
            }, 1000);
          })
          .catch((err) => {
            this.error = err.message;
            this.$snotify.error(err.message);

          //  console.log("err: " + err.message);
          });
      } else {
        this.$snotify.error("The email password combination is incorrect.");
      }
    },
  },
};
</script>
